import { createFileRoute } from '@tanstack/react-router'
import { PointCloudHome } from 'pages/pointClouds/PointCloudHome'

const RouteComponent = () => {
  const { siteId } = Route.useSearch()

  if (!siteId) {
    return null
  }

  return <PointCloudHome siteId={siteId} />
}

export const Route = createFileRoute('/point-cloud')({
  component: RouteComponent,
  staticData: {
    title: 'Point Cloud',
  },
})
